import { CANCELED_BY_OPTIONS, CancellationReason } from '../../types/reservation';

export const MIN_TIMES_TO_CLONE = 1;
export const MAX_TIMES_TO_CLONE = 52;

export const canceledByOptions = [
  { label: 'Empleado', value: CANCELED_BY_OPTIONS.CANCELED_BY_ADMIN },
  { label: 'Cliente', value: CANCELED_BY_OPTIONS.CANCELED_BY_USER },
];

export const cancellationReasonOptions = [
  { label: 'Baja de usuario', value: CancellationReason.USER_DISABLED },
  { label: 'No se presentó', value: CancellationReason.USER_DID_NOT_SHOW_UP },
  { label: 'Conflicto de horarios', value: CancellationReason.SCHEDULE_CONFLICT },
  { label: 'Problema de salud', value: CancellationReason.HEALTH_ISSUE },
  { label: 'Motivo personal', value: CancellationReason.PERSONAL_REASON },
  { label: 'Ya no necesita el servicio', value: CancellationReason.NO_LONGER_NEEDED },
  { label: 'Problema de transporte', value: CancellationReason.TRANSPORT_ISSUE },
  { label: 'Otro', value: CancellationReason.OTHER },
];
